export enum Operator {
  In,
  NotIn,
  Equal,
  NotEqual,
  Less,
  LessOrEqual,
  Greater,
  GreaterOrEqual,
  Between,
  NotBetween,
  IsNull,
  IsNotNull,
  Contains,
  DoesNotContain,
}

export namespace Operator {
  let elements = [
    Operator.In,
    Operator.NotIn,
    Operator.Equal,
    Operator.NotEqual,
    Operator.Less,
    Operator.LessOrEqual,
    Operator.Greater,
    Operator.GreaterOrEqual,
    Operator.Between,
    Operator.NotBetween,
    Operator.IsNull,
    Operator.IsNotNull,
    Operator.Contains,
    Operator.DoesNotContain,
  ];
  let alias = "com.bcdfx.model.query.Operator";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
